"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    scrollAreaVariants: ()=>scrollAreaVariants,
    scrollAreaEmphases: ()=>scrollAreaEmphases,
    scrollAreaEmphasisVariants: ()=>scrollAreaEmphasisVariants,
    scrollAreaSlots: ()=>scrollAreaSlots
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const scrollAreaEmphasisVariants = {
    regular: {
        content: 'bg-primary-1',
        scrollbar: 'bg-neutral-4/40',
        thumb: 'bg-neutral-13/40'
    },
    medium: {
        content: 'bg-primary-3',
        scrollbar: 'bg-neutral-1/60',
        thumb: 'bg-neutral-13/40'
    },
    bold: {
        content: 'bg-primary-11 text-primary-1',
        scrollbar: 'bg-neutral-1/20',
        thumb: 'bg-neutral-1/60'
    }
};
const scrollAreaEmphases = Object.keys(scrollAreaEmphasisVariants);
const scrollAreaSlots = {
    root: 'max-w-[calc(100vw-8rem)]',
    viewport: 'outline-neutral-11/20 focus-visible:outline-primary-8 h-full overscroll-contain rounded-lg outline outline-1 -outline-offset-1 focus-visible:outline focus-visible:outline-2',
    content: 'flex flex-col gap-4 py-3 pl-4 pr-6',
    scrollbar: 'mx-1 my-2 flex w-1 justify-center rounded-full opacity-0 transition-opacity delay-300 data-[hovering]:opacity-100 data-[scrolling]:opacity-100 data-[hovering]:delay-0 data-[scrolling]:delay-0 data-[hovering]:duration-75 data-[scrolling]:duration-75',
    thumb: 'w-full rounded-full'
};
const scrollAreaVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: scrollAreaSlots,
    variants: {
        emphasis: scrollAreaEmphasisVariants,
        popoverBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'gap-0 rounded-t-none outline-none outline-transparent',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        },
        dialogBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'gap-0 rounded-b-2xl rounded-t-none outline-none outline-transparent',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        },
        drawerBody: {
            true: {
                root: 'w-full max-w-[100%]',
                viewport: 'rounded-none outline-none outline-transparent',
                content: 'gap-0 bg-transparent px-0 py-0'
            }
        }
    },
    defaultVariants: {
        emphasis: 'regular',
        dialogBody: false,
        popoverBody: false
    }
});
exports.scrollAreaEmphases = __webpack_exports__.scrollAreaEmphases;
exports.scrollAreaEmphasisVariants = __webpack_exports__.scrollAreaEmphasisVariants;
exports.scrollAreaSlots = __webpack_exports__.scrollAreaSlots;
exports.scrollAreaVariants = __webpack_exports__.scrollAreaVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "scrollAreaEmphases",
    "scrollAreaEmphasisVariants",
    "scrollAreaSlots",
    "scrollAreaVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
